const LINKS = {
  CONTACT_DXPN:
    import.meta.env.VITE_TENANT_CONTACT_URL || `${import.meta.env.VITE_APP_BASE_URL}/contact`,
  CONTACT_BANK:
    import.meta.env.VITE_COMPANY_CONTACT_URL || `${import.meta.env.VITE_APP_BASE_URL}/contact`,
};

export default LINKS;
